<template>
    <div>
        <ul id="slider_list">
            <li v-for="(sliderItem, index) in sliderItems" :key="index" :class="{ active: index == 0 }" :id="'si_' + index" @click="toggleContent">
                <h2 class="theme-title">{{ sliderItem['name'] }}</h2>
                <div class="slider_content">
                    <img :src="'/loris/images/topics/' + sliderItem['id'] + '/' + sliderItem['id'] + '.' + sliderItem['image_extension'] + '/full/800,800/0/default.jpg'" :class="[ { img_is_visible: imgIsVisible }, 'img-fluid' ]" :alt="sliderItem['name']">
                    <button type="button" class="homeregest btn btn-light btn-sm btn-show infos">{{ translate('label.info') }}</button>
                    <div :class="[ { text_is_visible: textIsVisible }, 'slider_text' ]">
                    <p>{{ sliderItem['description'] }}</p>
                    <a class="homeregest btn btn-light btn-sm btn-show charters" :href="'/charters/?q=&selectedFilters' + encodeURIComponent('[topic_names_' + locale + '][0]') + '=' + sliderItem['name']" v-html="translate('label.charters.show.responsive')"></a>
                    <a class="homeregest btn btn-light btn-sm btn-show locations" :href="'/locations/' + sliderItem['id']" v-html="translate('label.locations.show.responsive')"></a>
                    </div>
                </div>
            </li>
        </ul>
        <ul id="slider_dots">
            <li v-for="(sliderItem, index) in sliderItems" :key="JSON.stringify(sliderItem)" :class="{ active: index == 0 }" :id="'sd_' + index" @click="showSliderItem(index)">•</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        sliderItems: { type: Array, required: true },
        autoplayInterval: { type: Number, required: false, default: 5000 },
        locale: { type: String, required: true }
    },

    data() {
        return {
            imgIsVisible: true,
            textIsVisible: false,
            autoplayId: '',
            currentSlideIndex: 0
        }
    },
    mounted() {
        this.autoplay();
    },

    methods: {
        toggleContent() {
            this.imgIsVisible = !this.imgIsVisible;
            this.textIsVisible = !this.textIsVisible;
            clearInterval(this.autoplayId);
        },
        showSliderItem(iItemIndex) {
            this.imgIsVisible = true;
            this.textIsVisible = false;
            let allLiActiveElements = Array.from(document.querySelectorAll("li.active"));
            for (let oElement of allLiActiveElements) {
                oElement.classList.remove('active')
            }
            document.getElementById("si_" + iItemIndex).className = "active";
            document.getElementById("sd_" + iItemIndex).className = "active";
            this.currentSlideIndex = iItemIndex;
            // stop autoplay, if a dot was clicked
            if (typeof event !== "undefined") {
                clearInterval(this.autoplayId);
            }
        },
        autoplay() {    
            this.autoplayId = setInterval(() => {
                let iCountSlides = this.sliderItems.length;
                var iNextItemIndex = this.currentSlideIndex + 1;
                if (iNextItemIndex == iCountSlides) {
                    iNextItemIndex = 0;
                }
                this.showSliderItem(iNextItemIndex);
            }, this.autoplayInterval);
        },
        beforeDestroy() {
            clearInterval(this.autoplayId);
        },

    },
}
</script>

<style lang="scss" scoped>

    #slider_list { 
        position:relative; 
        padding-left:0;
        margin-bottom:0;
        li {
            list-style: none;
            opacity:0;
            display:none;
            cursor:pointer;
            position:relative;
            div.slider_content {
                position:relative;
                .infos { 
                    position:absolute;
                    right:1rem;
                    bottom:1rem;
                    left:auto;
                    margin:0;
                }
            }
            div.slider_text {
                background-color:rgba(185, 187, 188, 1);
                padding:1rem;
                position:absolute;
                top:0; left:0; bottom:0; right:0;
                    display:none;
                    opacity:0;
                    visibility:hidden;
                    animation: fadeout 1s;
                &.slider_text.text_is_visible {
                    opacity:1;
                    visibility:visible;
                    display:block;
                    animation: fadein 1s;
                }
                p { 
                    position:absolute; 
                    top:.75rem; 
                    bottom:2.75rem;
                    right:1rem; 
                    left:1rem;
                    overflow-y:auto;
                }
                .locations { 
                    position:absolute;
                    right:1rem;
                    bottom:1rem;
                    left:auto;
                    margin:0;
                }
                .charters { 
                    position:absolute;
                    left:1rem;
                    bottom:1rem;
                    margin:0;
                }
            }
            img {
                opacity:0;
                visibility:hidden;
                animation: fadeout 1s;
                display:block;
                &.img_is_visible {
                    opacity:1;
                    visibility:visible;
                    animation: fadein 1s;
                }
            }

            &.active {
                opacity:1;
                display:block;
            }

        }
        
    }

    #slider_dots { 
        position:relative; 
        padding-left:0; 
        li {
            list-style: none;
            display:inline-block;
            margin-right:.75rem;
            font-size:2.75rem;
            line-height:1;
            color:#999;
            cursor:pointer;
        }
        li.active { color:#000; }
    }
    
    @keyframes fadein {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes fadeout {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
</style>